import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function VerifyMagicLink() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setStatus('error');
        setError('No token provided');
        return;
      }

      try {
        const { data } = await axios.get(
          `${API_URL}/auth/verify-magic-link?token=${token}`,
          { withCredentials: true }
        );

        await checkAuth();

        if (data.needs_setup) {
          navigate('/setup', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (err) {
        setStatus('error');
        setError(err.response?.data?.detail || 'Invalid or expired magic link');
      }
    };

    verifyToken();
  }, [searchParams, navigate, checkAuth]);

  if (status === 'error') {
    return (
      <div className="mobile-container min-h-screen flex flex-col items-center justify-center px-6 bg-bone">
        <div className="w-full max-w-sm text-center">
          <h1 className="text-4xl font-black font-heading uppercase tracking-tight text-userRed mb-4">
            Error
          </h1>
          <p className="text-base text-graphite mb-8">{error}</p>
          <button
            onClick={() => navigate('/signin')}
            className="w-full h-14 bg-userRed text-bone font-black text-sm uppercase tracking-wider"
            data-testid="back-to-signin-button"
          >
            Back to Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mobile-container min-h-screen flex flex-col items-center justify-center px-6 bg-bone">
      <div className="text-center">
        <div className="text-6xl font-black font-heading text-graphite">B</div>
        <div className="text-xs uppercase tracking-wider text-graphite/60 mt-2">Verifying...</div>
      </div>
    </div>
  );
}
